import { updatesItems } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[960px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-3">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            最新动态
          </h2>
          <span className="text-xs text-foreground-400 whitespace-nowrap">实时追踪</span>
        </div>
        <p className="text-sm text-foreground-500 mb-10">
          新剧上线、热门更新、站内公告，追剧快讯一手掌握
        </p>

        <div className="relative pl-8 border-l-2 border-background-200 space-y-8">
          {updatesItems.map((item, idx) => (
            <div key={item.id} className="relative">
              <span
                className={`absolute -left-[calc(2rem+5px)] top-1 w-2.5 h-2.5 rounded-full border-2 border-background-50 ${
                  idx === 0 ? 'bg-primary-500' : 'bg-background-300'
                }`}
              ></span>
              <div className="flex flex-col gap-1">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="text-xs text-foreground-400 font-mono whitespace-nowrap">{item.date}</span>
                  <span className={`px-2 py-0.5 rounded-md text-xs font-medium whitespace-nowrap ${
                    item.tag === '新剧上线' || item.tag === '全集上线'
                      ? 'bg-primary-100 text-primary-700'
                      : item.tag === '热播更新'
                      ? 'bg-accent-100 text-accent-700'
                      : 'bg-secondary-100 text-secondary-700'
                  }`}>
                    {item.tag}
                  </span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}